var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 69,
    viewBox: "0 0 71 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1132 28.3061L33.0576 42.6414C31.666 43.9667 29.4118 43.9667 28.0202 42.6414L20.4977 35.4771C19.1096 34.1585 19.1096 32.0184 20.4977 30.6964C21.8822 29.3779 24.1329 29.3779 25.5174 30.6964L28.0308 33.0901C29.4153 34.4087 31.6624 34.4087 33.0505 33.0901L43.0934 23.5254C44.4779 22.2035 46.7251 22.2035 48.1132 23.5254C49.5012 24.844 49.5012 26.9842 48.1132 28.3061ZM63.9 0.690491H7.09999C3.17724 0.690491 0 3.71644 0 7.45239V61.5476C0 65.2802 3.17724 68.3095 7.09999 68.3095H63.9C67.8228 68.3095 71 65.2802 71 61.5476V7.45239C71 3.71644 67.8228 0.690491 63.9 0.690491Z",
    fill: "#2DCE89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b8968a35650fff8771a55ed3d910b45b.svg";
export { ForwardRef as ReactComponent };